import { msg } from '@lingui/macro';
import { md } from 'content/types';

type ShowHra = { showHra: boolean };
type IsMidyear = { isMidyear: boolean };

export default {
  title: ({ showHra }: ShowHra) =>
    msg`Almost there. Let us know if you have a Health Savings Account (HSA)${
      showHra ? ' or Health Reimbursement Arrangement (HRA)' : ''
    }.`,
  intro: ({ showHra }: ShowHra) =>
    msg`Let us know if you have any money left over in an HSA${
      showHra ? ' or HRA' : ''
    }, and we’ll calculate how to put it to use.`,

  whyDoWeNeedThis: md(
    msg`Since an HSA allows account owners to pay for current and save for future
qualified healthcare expenses, this information helps us calculate how your
HSA savings may cover your estimated, projected out-of-pocket costs and how
hypothetical investment returns may help cover healthcare services in retirement.`,
  ),

  callout: md(msg`
Health Savings Accounts are only available with high-deductible health plans
(HDHP). An HSA is a way for you and your household to contribute, save and pay
for eligible medical expenses now and into retirement as long as you have funds
in your account. It helps you cover out-of-pocket qualified medical expenses
with the added bonus of tax savings when you are enrolled in a high deductible health plan.`),

  balanceDescription: ({ isMidyear }: IsMidyear) =>
    isMidyear
      ? msg`If you do not have an HSA balance, please leave this field blank and click “Save and Continue” and see your results.`
      : msg`Estimate how much of your HSA will be available by the start of this coming
plan year (i.e. if you have $1,000 now, but plan to use $500 before the end 
of this plan year, enter $500). If you do not have an HSA balance, please 
leave this field blank and click “Save and Continue” and see your results.`,
};
